import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { useModuleSettings } from '../../context/adminSettingsContext'
import { contactUsList } from '../../slice/cmsSlice'

const Contact = () => {
    const dispatch = useDispatch()
    const { contactList } = useSelector(state => state.cms)

    const { page, setPage, limit, setLimit } = useModuleSettings()

    const [statusFilter, setStatusFilter] = useState('all')
    const [searchQuery, setSearchQuery] = useState('')
    const [searchDebounce, setSearchDebounce] = useState('')

    // Debounce search
    useEffect(() => {
        const timer = setTimeout(() => {
            setSearchDebounce(searchQuery)
            setPage(1)
        }, 500)
        return () => clearTimeout(timer)
    }, [searchQuery])

    // API call
    useEffect(() => {
        dispatch(contactUsList({
            page,
            limit,
            filter: statusFilter !== 'all' ? statusFilter : undefined,
            search: searchDebounce || undefined,
        }))
    }, [dispatch, page, limit, statusFilter, searchDebounce])

    // Table Columns
    const columns = [
        {
            name: 'Sr No',
            width: '80px',
            selector: (_, index) =>
                ((contactList?.paging?.page_no || 1) - 1) * limit + index + 1,
        },
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            width: '80px',
        },
        {
            name: 'Name',
            minWidth: '180px',
            cell: row => (
                <div>
                    <div style={{ fontWeight: 500 }}>
                        {row.first_name} {row.last_name}
                    </div>
                </div>
            ),
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            minWidth: '200px',
        },
        {
            name: 'Message',
            minWidth: '250px',
            cell: row => (
                <div
                    title={row.description}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '230px',
                        fontSize: '13px'
                    }}
                >
                    {row.description}
                </div>
            ),
        },
        {
            name: 'Status',
            width: '120px',
            cell: row => (
                <span className={`badge ${row.is_active ? 'bg-success' : 'bg-secondary'}`}>
                    {row.is_active ? 'Active' : 'Inactive'}
                </span>
            )
        },
        {
            name: 'Date',
            selector: row =>
                row.createdAt
                    ? moment(row.createdAt).local().format('DD MMM YYYY, hh:mm A')
                    : 'NA',
            sortable: true,
            minWidth: '180px',
        }
    ]

    return (
        <div className="container-fluid px-4 py-3">
            {/* Header */}
            <div className="mb-3">
                <h4>Contact Messages</h4>
            </div>

            {/* Search & Filter */}
            <div className="card mb-3 p-3">
                <div className="row g-2">
                    <div className="col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by name, email or message..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <div className="col-md-4">
                        <select
                            className="form-select"
                            value={statusFilter}
                            onChange={(e) => {
                                setStatusFilter(e.target.value)
                                setPage(1)
                            }}
                        >
                            <option value="all">All</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="deleted">Deleted</option>
                        </select>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="card">
                <DataTable
                    columns={columns}
                    data={contactList?.data || []}
                    pagination
                    paginationServer
                    paginationTotalRows={contactList?.paging?.total || 0}
                    paginationPerPage={limit}
                    paginationDefaultPage={contactList?.paging?.page_no || 1}
                    onChangeRowsPerPage={(newLimit) => {
                        setLimit(newLimit)
                        setPage(1)
                    }}
                    onChangePage={(newPage) => setPage(newPage)}
                    progressPending={contactList?.loading}
                    highlightOnHover
                    responsive
                    noDataComponent={
                        <div className="p-4 text-center text-muted">
                            {searchQuery
                                ? 'No contact messages found'
                                : 'No contact data available'}
                        </div>
                    }
                />
            </div>
        </div>
    )
}

export default Contact